import { createContext, useContext } from 'react';
import type { AuthenticationValidation } from '../hooks/useAuthenticationValidation';
import type { AuthenticationSubTab } from '../tabs/AuthenticationTab';

export type AuthenticationValidationContextValue = AuthenticationValidation & {
  setSubTab: (subTab: AuthenticationSubTab) => void;
};

export const AuthenticationValidationContext =
  createContext<AuthenticationValidationContextValue | null>(null);

export const useAuthenticationValidationContext =
  (): AuthenticationValidationContextValue => {
    const context = useContext(AuthenticationValidationContext);
    if (context === null) {
      throw new Error(
        'useAuthenticationValidationContext must be used within AuthenticationValidationContext.Provider',
      );
    }
    return context;
  };
